import React, { useContext } from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, Box } from "@mui/material";
import SupportIcon from "@mui/icons-material/Support";
import logo from  "../../../assets/logo/logo-sem-frase-branco.png";
import FeedIcon from '@mui/icons-material/Feed';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LogoutIcon from '@mui/icons-material/Logout';
import WalletIcon from '@mui/icons-material/Wallet';
import PolicyRoundedIcon from '@mui/icons-material/PolicyRounded';
import { IDrawerItem } from "..";
import UserContext from "../../../context";
import { useNavigate } from "react-router-dom";
const Sidebar: React.FC<{ currentPage: IDrawerItem; setCurrentPage(currentPage: IDrawerItem): void }> = ({
  currentPage,
  setCurrentPage,
}) => {

  const logout = () => {
    sessionStorage.clear();
    window.location.replace("/")
  }

  const menuItems = [
    { key: "noticias", label: "Notícias", icon: <FeedIcon />, f: () => setCurrentPage("noticias") },
    { key: "meu-plano", label: "Meu Plano", icon: <HealthAndSafetyIcon />, f: () => setCurrentPage("meu-plano") },
    { key: "financeiro", label: "Financeiro", icon: <WalletIcon />, f: () => setCurrentPage("financeiro") },
    { key: "atendimento", label: "Atendimento", icon: <SupportIcon />, f: () => setCurrentPage("atendimento") },
    { key: "politica", label: "Política e Privacidade", icon: <PolicyRoundedIcon />, f: () => setCurrentPage("politica") },
    { key: "sair", label: "Sair da Conta", icon: <LogoutIcon />, f: logout },
  ];

  const ctx = useContext(UserContext);

  const navigate = useNavigate();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 300,
        position: "relative",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 300,
          boxSizing: "border-box",
          backgroundColor: "#004387",
          color: "#fff",
        },
      }}
    >
      <Box
        component="button"
        onClick={() => navigate("/")}
        sx={{
          backgroundColor: "transparent",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <img src={logo} alt="Logo_Branco" style={{ width: "90%" }} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <Typography variant="body1">{ctx?.user?.nome} {ctx?.user?.sobrenome}</Typography>
      </Box>
      <List>
        {menuItems.map((item) => (
          <ListItem
            key={item.key}
            onClick={item.f}
            sx={{
              cursor: "pointer",
              backgroundColor: currentPage === item.key ? "rgba(255, 255, 255, 0.2)" : "transparent",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
              transition: "background-color 0.3s ease",
            }}
          >
            <ListItemIcon sx={{ color: "#fff" }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
